import { EnvironmentProviders, Injectable, InjectionToken, inject, makeEnvironmentProviders } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { distinctUntilChanged, filter, map } from 'rxjs';
import { environment } from '../../../environments/environment';
import { clientsFor } from './clients';

export interface AnalyticsClient {
  pageView(url: string): void;
}

export const ANALYTICS_CLIENTS = new InjectionToken<AnalyticsClient[]>('ANALYTICS_CLIENTS');

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  private readonly router = inject(Router);
  private readonly clients = inject(ANALYTICS_CLIENTS);

  start() {
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        // the query string carries the email and partner tokens; the trackers only get the path
        map((event) => event.urlAfterRedirects.split('?')[0]),
        distinctUntilChanged(),
      )
      .subscribe((url) => this.pageView(url));
  }

  pageView(url: string) {
    this.clients.forEach((client) => client.pageView(url));
  }
}

export function provideAnalytics(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: ANALYTICS_CLIENTS, useValue: clientsFor(environment.ENV_NAME, environment.production) },
  ]);
}
